import { useNavigate } from 'react-router-dom';
import { maskStyle } from '../../utils/icons';
import '../../css/shared/BackHeader.css';

export default function BackHeader({ title }) {
  const navigate = useNavigate();
  return (
    <div className="backhead">
      <button className="backhead-btn" onClick={() => navigate(-1)} aria-label="Back">
        <span className="bc" style={maskStyle('ic-chevron')} />
      </button>
      <span className="backhead-title">{title}</span>
    </div>
  );
}
